import 'angular';
import * as _ from 'lodash-es';

angular.module("GorillaBoy.ClientMetrics")
.config(['$provide', function clientMetricsConfigFn($provide) {
    $provide.decorator('$log', ['$delegate', '$injector', function $logDecoratorFn($delegate, $injector) {
        function decorateFunction(name: string) {
            var originalFn = $delegate[name];
            $delegate[name] = function decoratedWarn(msg: any) {
                const ClientMetricsService = $injector.get('ClientMetricsService');                
                if (typeof msg !== 'string') {
                    try {
                        msg = JSON.stringify(msg);    
                    } catch(e) {
                        ClientMetricsService.addEventObjectToSession({
                            event: "LOG_ERROR",
                            metadata: "Error occured while stringifying msg",
                            stack: e.stack,
                            timestamp : new Date().toISOString()
                        });                                        
                    }                    
                }
                ClientMetricsService.addEventObjectToSession({
                    event: "LOG_" + name.toUpperCase(),
                    metadata: msg,                    
                    timestamp : new Date().toISOString()
                });                                
                originalFn.apply($delegate, arguments);
            };
            //The mock implementation has logs array on the function itself
            if (originalFn.logs) {
                $delegate[name].logs = originalFn.logs;
            }
        }
        ['log','debug','info','warn','error'].forEach(decorateFunction);
        return $delegate;
    }]);

}]);
